import { movies } from "@/mocks/movies";
import { articles } from "@/mocks/news";
import type { Article, Movie } from "@/types/content";

export const allGenres = ["动作", "科幻", "爱情", "喜剧", "剧情", "恐怖", "战争", "冒险"];

export function getMovieById(id: string | undefined): Movie | undefined {
  if (!id) return undefined;
  return movies.find((movie) => movie.id === id);
}

export function getArticleById(id: string | undefined): Article | undefined {
  if (!id) return undefined;
  return articles.find((article) => article.id === id);
}

export function getArticlesByMovie(movieId: string): Article[] {
  return articles.filter((article) => article.movieId === movieId);
}

export function getRelatedMovies(movie: Movie, limit = 3): Movie[] {
  return movies
    .filter((item) => item.id !== movie.id)
    .map((item) => {
      const shared = item.genres.filter((genre) => movie.genres.includes(genre)).length;
      const yearGap = Math.abs(item.year - movie.year);
      return { item, score: shared * 10 - yearGap };
    })
    .sort((a, b) => b.score - a.score || b.item.popularity - a.item.popularity)
    .slice(0, limit)
    .map((entry) => entry.item);
}

export function getRelatedArticles(article: Article, limit = 3): Article[] {
  return articles
    .filter((item) => item.id !== article.id)
    .map((item) => {
      const sameMovie = item.movieId && item.movieId === article.movieId ? 20 : 0;
      const sameType = item.type === article.type ? 6 : 0;
      return { item, score: sameMovie + sameType };
    })
    .sort((a, b) => b.score - a.score || b.item.date.localeCompare(a.item.date))
    .slice(0, limit)
    .map((entry) => entry.item);
}

export function searchMovies(keyword: string): Movie[] {
  const word = keyword.trim().toLowerCase();
  if (!word) return [];
  return movies.filter((movie) => {
    const haystack = [
      movie.title,
      movie.originalTitle,
      movie.director,
      movie.genres.join(" "),
      movie.cast.join(" "),
      movie.synopsis,
      String(movie.year),
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(word);
  });
}

export function searchArticles(keyword: string): Article[] {
  const word = keyword.trim().toLowerCase();
  if (!word) return [];
  return articles.filter((article) => {
    const haystack = [article.title, article.excerpt, article.author, article.type, article.content.join(" ")]
      .join(" ")
      .toLowerCase();
    return haystack.includes(word);
  });
}

export function formatDate(date: string): string {
  const [year, month, day] = date.split("-");
  return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}

export function getMovieTitle(movieId?: string): string {
  const movie = getMovieById(movieId);
  return movie ? `${movie.title}（${movie.year}）` : "影片资料";
}